import { render, staticRenderFns } from "./PackagesSection.vue?vue&type=template&id=03998ae2&scoped=true"
import script from "./PackagesSection.vue?vue&type=script&lang=ts"
export * from "./PackagesSection.vue?vue&type=script&lang=ts"
import style0 from "./PackagesSection.vue?vue&type=style&index=0&id=03998ae2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03998ae2",
  null
  
)

export default component.exports